// Libs
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import { getListNotification, readNotification } from '~/thunks/notification/notificationThunk';
import {
  BASE_PAGINATION_DEFAULT_CURRENT_PAGE,
  DEFAULT_LIMIT_PAGE,
  DEFAULT_NUMBER_ZERO,
} from '~/utils/constants/common';
import { IQueryParamBase } from '~/utils/interface/common';
import { INotification } from '~/utils/interface/notification';
import { NotificationStatusEnum } from '~/utils/enum/common';

export interface NotificationState {
  isRefreshNotification: boolean;
  notificationUnread: number;
  queryParams: IQueryParamBase;
  notificationList: INotification[];
}

const initialState: NotificationState = {
  isRefreshNotification: false,
  notificationUnread: DEFAULT_NUMBER_ZERO,
  queryParams: {
    page: BASE_PAGINATION_DEFAULT_CURRENT_PAGE,
    limit: DEFAULT_LIMIT_PAGE,
  },
  notificationList: [],
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setIsRefreshNotification(state, action: PayloadAction<boolean>) {
      state.isRefreshNotification = action.payload;
      state.queryParams = initialState.queryParams;
    },
    setParamsNotification(state, action: PayloadAction<IQueryParamBase>) {
      state.queryParams = { ...state.queryParams, ...action.payload };
    },
  },
  extraReducers(builder) {
    // GET: Get list notification
    builder
      .addCase(getListNotification.pending, (state) => {})
      .addCase(getListNotification.fulfilled, (state, action) => {
        state.notificationUnread = action.payload.data.countNotificationUnRead;
        const { responses, countNotificationUnRead } = action.payload.data;
        const { page } = state.queryParams;

        state.notificationList =
          page === BASE_PAGINATION_DEFAULT_CURRENT_PAGE
            ? [...responses]
            : [...state.notificationList, ...responses];

        state.notificationUnread = countNotificationUnRead ?? DEFAULT_NUMBER_ZERO;
      })
      .addCase(getListNotification.rejected, (state) => {});

    // PUT: Read notification
    builder
      .addCase(readNotification.pending, (state) => {})
      .addCase(readNotification.fulfilled, (state, action) => {
        const index = state.notificationList.findIndex((item) => item.id === action.payload.data.id);
        if (index !== -1) {
          state.notificationList[index].status = NotificationStatusEnum.READ;
        }
        state.notificationUnread = action.payload.data.countNotificationUnRead;
      })
      .addCase(readNotification.rejected, (state) => {});
  },
});

// Action
export const notificationActions = notificationSlice.actions;

// Selectors
export const selectIsRefreshNotification = (state: RootState) => state.notification.isRefreshNotification;
export const selectNotificationUnread = (state: RootState) => state.notification.notificationUnread;

// Reducer
const notificationReducer = notificationSlice.reducer;
export default notificationReducer;
